import '../css/styles.scss'
import Site from '../lib/Site.js'

window._site = new Site()
